module.exports = __webpack_public_path__ + "static/media/menu_roleManagement_default.44ace4f3.svg";